import AdditionalPrice from "../../../internet/showcase/components/AdditionalPrice.vue";
import GenericButtonCta from "../../../../../common/broadband/components/GenericButtonCta.vue";
import XdslLineIntentionPopin from "../../../../../common/broadband/components/XdslLineIntentionPopin.vue";
import Faq from "./components/Faq.vue";
import InternetLiveBoxBlock from "../../../../../common/broadband/demands/ordering/components/InternetLiveBoxBlock.vue";
import InlinePromise from "../../../../../common/components/ob1/InlinePromise.vue";
import PriceWithDetails from "../../../../../common/components/custom/PriceWithDetails.vue";
import PriceDetailsPopin from "../../../../../fmfmo/acquisition/vitrine/fragments/PriceDetailsPopin.vue";
import {PromotionType} from "../../../../../common/components/ob1/models/Price";
import {formatPriceToEuros} from "../../../../../common/utils/Number";

window.app = new Vue({
    el: "#internet-offer",
    name: "InternetOffer",
    components: {
        GenericButtonCta,
        XdslLineIntentionPopin,
        Faq,
        InternetLiveBoxBlock,
        InlinePromise,
        PriceWithDetails,
        PriceDetailsPopin,
        AdditionalPrice,
    },
    data: {
        pageVue: pageDto
    },
    computed: {
        prospectPromotionType() {
            if (this.pageVue.prospectHeaderPrice) {
                if (this.pageVue.prospectHeaderPrice.showPromoDuration) {
                    return PromotionType.PROMO_DURATION;
                } else if (this.pageVue.prospectHeaderPrice.showEndOfPromotionPrice) {
                    return PromotionType.END_OF_PROMO;
                }
            }
            return undefined;
        },
        prospectPromotionPrice() {
            if (this.pageVue.prospectHeaderPrice) {
                return formatPriceToEuros(this.pageVue.prospectHeaderPrice.price, false)
            }
            return undefined;
        },
        prospectInitialPrice() {
            if (this.pageVue.prospectHeaderPrice) {
                return formatPriceToEuros(this.pageVue.prospectHeaderPrice.initialPrice, false)
            }
            return undefined;
        },
    },
    mounted() {
        this.addElementsForModalToggle();
    },
    updated() {
        this.addElementsForModalToggle();
    },
    methods: {
        addElementsForModalToggle() {
            document.querySelectorAll(".offer-attributes").forEach(
                function (edito) {
                    const {oeventCategory, oeventLabel} = edito.dataset;

                    edito.querySelectorAll("a").forEach(
                        function (link) {
                            const hrefAttr = link.getAttribute("href");
                            if (hrefAttr.startsWith("#")) {
                                link.target = "_self";
                                link.dataset.bsToggle = "modal";
                                link.dataset.oeventCategory = oeventCategory;
                                link.dataset.oeventLabel = oeventLabel;
                                link.dataset.oeventAction = hrefAttr.substr(1);
                            } else {
                                link.target = "_blank";
                                link.dataset.oeventCategory = oeventCategory;
                                link.dataset.oeventLabel = "ouverture_nouvelle_fenetre";
                                link.dataset.oeventAction = hrefAttr.substr(1);
                            }
                        }
                    );
                }
            );
        },
    }
});
